import { UseFormReturn, Controller, UseFormResetField, UseFormGetValues } from 'react-hook-form'
import { FormSelectAutocomplete } from '../../../components/forms/select/FormSelectAutocomplete'
import { TSitioForm } from '../models/sitioForm.type'
import { OpcionUsuarioSelect } from '../../../components/forms/select/OpcionesSelect'
import { ContactoSitio, NuevoObjResponsable, Nivel } from '../models'
import { NivelesCards } from './NivelesCards'
import { Alert } from '../../../components/alerts/Alert'

type TProps = {
  formSitio: UseFormReturn<TSitioForm>
  isModoEditar: boolean
  arrResponsables: ContactoSitio[]
  nivel: Nivel
  handleDragEnd: (arg: any) => void
  isBusquedaDeshabilitada: () => boolean
  agregaOpcionesSelect: (nombreResponsable: string, callback: Function) => void
  agregarResponsableCard:() => void
  agregarNivel: () => void
  eliminarNivel: (key: string) => void
  eliminarResponsable: (id: string, nivelKey: any) => void
}
/**
 * Panel de gestion de responsables por nivel.
 * - Modo crear: solo estado local; al guardar, se serializan con el sitio.
 * - Modo editar: altas/eliminaciones/cambios de nivel se persisten via API inmediatamente.
 */
export const Contactos = ({
  isModoEditar,
  agregarNivel,
  eliminarNivel,
  eliminarResponsable,
  arrResponsables,
  nivel,
  agregarResponsableCard,
  handleDragEnd,
  isBusquedaDeshabilitada,
  agregaOpcionesSelect,
  formSitio: {
    control,
    formState: { errors },
  },
}: TProps) => {
  return (
    <>
      <div className='col-11 mt-1 d-flex align-items-center flex-grow-1'>
        <h3>Responsables</h3>
        <span className='text-muted fw-lighter fs-4 ps-2'>| {arrResponsables?.length} total</span>
      </div>
      <div className='d-inline mb-6'>
        <div className='row mt-4'>
          <div className='col-6'>
            <Controller
              control={control}
              name='nombreResponsable'
              render={({ field: { onChange, value } }) => (
                <FormSelectAutocomplete
                  isObligatorio={false}
                  value={value}
                  cargaOpciones={agregaOpcionesSelect}
                  nombre='Busca el usuario para asociarlo como responsable: '
                  isDisabled={isBusquedaDeshabilitada()}
                  onChange={(e: Function) => {
                    onChange(e)
                  }}
                  placeholder='Ingrese un nombre'
                  Componente={OpcionUsuarioSelect}
                  errors={errors}
                />
              )}
            />
          </div>
          <div className='col-4 mt-10'>
            <button
              type='button'
              className='btn btn-primary'
              title='Agregar Card'
              onClick={() => agregarResponsableCard()}
              disabled={isBusquedaDeshabilitada()}>
              <i className='fa-solid fa-plus'></i>
              Agregar
            </button>
          </div>
        </div>
      </div>
      <div className='row mt-4'>
        {arrResponsables.length !== 0 ? (
          <div>
            <Alert
              mensaje={
                'Puedes mover los responsables entre los diferentes niveles, posicionate sobre las iniciales o nombre de alguno y arrastralo al nivel que requieras. Recuerda que no puedes dejar niveles intermedios vacíos. Todos los nuevos responsables que agregues serán asignados de forma predeterminada al primer nivel y a partir de este podras moverlo al nivel requerido.'
              }
              dismissible={true}
            />
            <NivelesCards
              agregarNivel={agregarNivel}
              eliminarNivel={eliminarNivel}
              eliminarResponsable={eliminarResponsable}
              nivelGlobal={nivel}
              isModoEditar={isModoEditar}
              handleDragEnd={handleDragEnd}
            />
          </div>
        ) : (
          <div className='d-flex flex-column justify-content-center h-100vh'>
            <i className='d-flex justify-content-center bi bi-person font-size-icon'></i>
            <i className='d-flex justify-content-center fs-4 pt-2'>Sin responsables registrados</i>
          </div>
        )}
      </div>
    </>
  )
}
